import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteAutoridadDeterminante,
  getAutoridadesDeterminantes,
  patchAutoridadDeterminante,
  postAutoridadDeterminante,
} from 'api/pae/autoridadesDeterminantes';
import { capitalize } from 'utils/normalizers';
import { getTiposDeAutoridadesDeterminantes } from 'api/pae/tiposDeAutoridadesDeterminantes';

const catalogs = [
  {
    permission: 'tipos_de_autoridades_determinantes',
    get: getTiposDeAutoridadesDeterminantes,
    formItemName: 'tipo_de_autoridad_determinante',
  },
];

export const permissionConfig = {
  permissionModel: 'autoridaddeterminantepae',
  catalogsModels: catalogs.map((c) => c.permission),
};

// eslint-disable-next-line react/prop-types
const AutoridadesDeterminantes = ({ permission }) => (
  <PlainCRUD
    title="Autoridad Determinante"
    get={getAutoridadesDeterminantes}
    post={postAutoridadDeterminante}
    patch={patchAutoridadDeterminante}
    delete={deleteAutoridadDeterminante}
    permission={permission}
    catalogs={catalogs}
    disabledStateField
    tableProps={{
      allowColumnSelector: false,
      deleteText: 'Cancelar',
    }}
    fields={[
      {
        ...defaultFields.descripcion,
        normalize: (value) => capitalize(value),
      },
      {
        name: 'tipo_de_autoridad_determinante',
        label: 'Tipo de Autoridad Determinante',
        useCatalog: true,
        type: 'select',
        colWidth: 120,
      },
    ]}
  />
);

export default AutoridadesDeterminantes;
